import { TODO_INTEGRATION_ICONS } from '../../TodoIntegration/constants';
import { TeamTaskWithOwner, TeamTasksGroupBy, normalizeTeamTaskProviderIconKey } from '../utils';
import { GROUP_OPTIONS, LAYOUT_OPTIONS } from './constants';
import { TeamTasksLayout, TeamTasksSegment } from './types';

export const isTeamTasksSegment = (value: unknown): value is TeamTasksSegment => {
  return value === 'team' || value === 'shared';
};

export const isTeamTasksGroupBy = (value: unknown): value is TeamTasksGroupBy => {
  return GROUP_OPTIONS.some((option) => option.value === value);
};

export const isTeamTasksLayout = (value: unknown): value is TeamTasksLayout => {
  return LAYOUT_OPTIONS.some((option) => option.value === value);
};

export const getTaskProviderIcon = (appFrom?: string) => {
  const iconKey = normalizeTeamTaskProviderIconKey(appFrom);

  return iconKey ? TODO_INTEGRATION_ICONS[iconKey] : null;
};

export const getGroupColumns = (groupBy: TeamTasksGroupBy) => {
  const hideOwner = groupBy === 'member';
  const hideBoard = groupBy === 'board';
  const columns = [
    '28px',
    'minmax(220px, 1fr)',
    hideOwner ? null : 'minmax(150px, 190px)',
    hideBoard ? null : 'minmax(120px, 150px)',
    'minmax(112px, 140px)',
  ].filter(Boolean);

  return {
    hideOwner,
    hideBoard,
    gridTemplateColumns: columns.join(' '),
  };
};

type TeamTFunction = (
  key: string,
  options?: Record<string, unknown> & { defaultValue?: string }
) => string;

export const getOwnerShortName = (taskItem: TeamTaskWithOwner, t?: TeamTFunction) => {
  if (taskItem.owner.isCurrentUser) {
    return t ? t('team.common.you') : 'You';
  }

  return (
    taskItem.owner.name
      .replace(/\s*\(You\)\s*$/, '')
      .trim()
      .split(/\s+/)[0] || (t ? t('team.common.teammate') : 'Teammate')
  );
};
